import React, { Component } from "react";
import { Button } from "reactstrap";
import WelcomeInfographic from "./../../welcome_infographic.svg";
import { connect } from "react-redux";
import axios from "./../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { isMobile } from "../../utils/deviceInfo";
import { isTrivvyProduct } from "../../utils/constants";

class Welcome extends Component {
  navigate = () => {
    if(isTrivvyProduct()){
      this.props.history.push("/setup/personal-details");
    }
    const { profile } = this.props.user;
    if (profile.orgAdmin && profile.organizationId.isOrgConfigured !== true) {
      this.props.history.push("/setup/select-industry");
    } else {
      this.props.history.push("/setup/personal-details");
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { profile } = this.props.user;
    const imgWidth = isMobile ? "185.32px" : "271.32px";
    return (
      <div className="page-title-box">
        <div className="title-text">
          Welcome to {isTrivvyProduct() ? "Trivvy" : "OurOffice"}
          {profile.firstName ? ", " + profile.firstName + "!" : "!"}
        </div>
        {!isMobile && <hr className="separator-line" />}
        <div className="setup-content">
          {isTrivvyProduct() ? (
            <div>
              Let’s fill out your profile. This information is important to have
              an awesome experience and also to collaborate effectively with
              your teammates.
            </div>
          ) : (
            <div>
              {" "}
              Let’s fill out your profile information. This information is used
              to improve your experience on this platform, and also helps create
              anonymously aggregated benchmarks to improve diversity, inclusion
              and belonging in your organization.
            </div>
          )}
        </div>
        <div className={`text-center`} style={{ marginTop: "40px" }}>
          <img
            src={WelcomeInfographic}
            style={{ width: imgWidth, height: "200px" }}
          />
          <div>
            <Button
              color="primary"
              className={`${isMobile &&
                "btn-lg btn-block btn-height btn-lets-go"}`}
              style={{
                marginTop: "40px",
                fontWeight: "bolder",
                fontSize: "18px",
                lineHeight: "25px",
                paddingLeft: "7%",
                paddingRight: "7%",
                height: "40px",
              }}
              onClick={this.navigate}
            >
              Let's Go!
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps)(Welcome);
